import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, startWith } from 'rxjs';
import { commonModules } from 'src/app/app.config';
import { UnlinkedLocation, Venue, VenueService } from 'src/app/planvue-api';

export interface LocationDialogConfig {
  venue: Venue
}

export interface LocationDialogResult {
  selectedLocation: UnlinkedLocation | undefined;
}

@Component({
  selector: 'app-location-selection-dialog',
  templateUrl: './location-selection-dialog.component.html',
  standalone: true,
  imports: [...commonModules],
  styleUrl: './location-selection-dialog.component.scss'
})
export class LocationSelectionDialogComponent implements OnInit {
  venue: Venue;
  venueService: VenueService = inject(VenueService);
  locations: UnlinkedLocation[] = [];
  selectedLocation: UnlinkedLocation | undefined;
  locationControl = new FormControl<string | UnlinkedLocation>('');
  filteredLocations: Observable<UnlinkedLocation[]>;

  constructor(public dialog: MatDialogRef<LocationSelectionDialogComponent>,  @Inject(MAT_DIALOG_DATA) public config: LocationDialogConfig) {
    this.venue = config.venue;
    this.filteredLocations = this.locationControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (typeof value === 'string') {
          // Typing clears any previously selected location until an option is picked.
          this.selectedLocation = undefined;
          return this.filterLocations(value);
        }
        return this.locations;
      })
    );
  }

  ngOnInit(): void {
    this.venueService.getUnlinkedLocations(this.venue.id!).subscribe((locations) => {
      this.locations = locations;
      this.locationControl.setValue(this.locationControl.value ?? '');
    });
  }

  displayLocation(location: UnlinkedLocation | string | null): string {
    if (!location || typeof location === 'string') {
      return location ?? '';
    }
    return location.description ? `${location.name} - ${location.description}` : location.name;
  }

  onLocationSelected(event: MatAutocompleteSelectedEvent): void {
    this.selectedLocation = event.option.value as UnlinkedLocation;
  }

  private filterLocations(search: string): UnlinkedLocation[] {
    const term = search.trim().toLowerCase();
    if (!term) {
      return this.locations;
    }
    return this.locations.filter((location) =>
      `${location.name} ${location.description ?? ''}`.toLowerCase().includes(term)
    );
  }

  onDismiss(): void {
    this.dialog.close({ selectedLocation: undefined} as LocationDialogResult );
  }

  onConfirm(): void {
    this.dialog.close({ selectedLocation: this.selectedLocation } as LocationDialogResult);
  }
}
